import storesApi from '../api/storesApi'
import { useApiClient } from '../context/AppContext'
import { FetchStore } from '../types/FetchStore'
import { ILoadStore } from '../types/ILoadStore'
import IResourceLoader from '../types/IResourceLoader'
import { IDetails } from '../types/IStoreDetails'
import useCallbackRef from './useCallbackRef'
import useResourceLoader from './useResourceLoader'

const useStoreLoader = (): [IResourceLoader<IDetails>, ILoadStore] => {
  const apiClient = useApiClient()

  const resource = useResourceLoader<IDetails>('Unable to load store')

  const loader = useCallbackRef<FetchStore>((code: string) =>
    resource.load(async () => storesApi.getStore(apiClient, code))
  )

  return [resource, loader]
}

export default useStoreLoader